import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import './Services/GlobalVariables.js'
import './assets/style/style.scss'
import DrawerLayout from 'vue-drawer-layout'
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueBarcodeScanner from 'vue-barcode-scanner'
import VueSignaturePad from 'vue-signature-pad';
import {VueEditor} from "vue2-editor";
import './registerServiceWorker'

// Vuetify setup
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);
const vuetify = new Vuetify({});

let options = {
    sensitivity: 100, // default is 100
    requiredAttr: true, // default is false
    controlSequenceKeys: ['NumLock', 'Clear'], // default is null
    callbackAfterTimeout: true // default is false
}
import VueTimeline from "@growthbunker/vuetimeline";

Vue.use(VueTimeline);
Vue.use(VueBarcodeScanner, options);

Vue.component('v-select', vSelect)
Vue.component('vue-editor', VueEditor)
Vue.component('loading', Loading);
Vue.use(VueSignaturePad);
Vue.use(DrawerLayout);
Vue.config.productionTip = false
Vue.use(VueTimeline);

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
}).$mount('#app')
